module.exports = __webpack_public_path__ + "img/ic-aim-point-purple.23a1816f.svg";